import React, { useCallback } from "react";
import { connect } from "react-redux";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { Territory } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

import ColorPicker from "@app/scene/map/components/ColorPicker";
import SharePicker from "@app/scene/map/components/SharePicker";
import { updateTerritory, updateTerritorySharing } from "@app/scene/map/store/actions";

import styles from "./TerritoryProps.module.scss";

interface Props {
  onUpdateTerritory?: typeof updateTerritory.request;
  onUpdateTerritorySharing?: typeof updateTerritorySharing.request;
  territory: Territory;
}

const TerritoryProps: React.FC<Props> = ({
  onUpdateTerritory,
  onUpdateTerritorySharing,
  territory,
}) => {
  const handleColorChange = useCallback(
    (color: AnyColor) => {
      onUpdateTerritory?.({ territory: { ...territory, color } });
    },
    [onUpdateTerritory, territory]
  );

  const handleOpacityChange = useCallback(
    (opacity: number) => {
      onUpdateTerritory?.({
        territory: { ...territory, territoryDetail: { ...territory.territoryDetail, opacity } },
      });
    },
    [onUpdateTerritory, territory]
  );

  const handleSave = useCallback(
    (userIds: User["id"][]) => {
      onUpdateTerritorySharing?.({ territory, userIdsToShareWith: userIds });
    },
    [territory, onUpdateTerritorySharing]
  );

  return (
    <div className={styles.container}>
      <SharePicker
        creatorUserId={territory.user.id}
        editable={territory.accessStatus.update}
        onChange={handleSave}
        userIds={territory.userIds}
      />
      <ColorPicker
        color={territory.color}
        editable={territory.accessStatus.update}
        onColorChange={handleColorChange}
        onOpacityChange={handleOpacityChange}
        opacity={territory.territoryDetail.opacity}
        showColorSpace
        showInput
      />
    </div>
  );
};

const mapDispatchToProps = {
  onUpdateTerritory: updateTerritory.request,
  onUpdateTerritorySharing: updateTerritorySharing.request,
};

export default connect(null, mapDispatchToProps)(TerritoryProps);
